import { render, staticRenderFns } from "./UpdateRole.vue?vue&type=template&id=28d2f8be&"
import script from "./UpdateRole.vue?vue&type=script&lang=js&"
export * from "./UpdateRole.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRole.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports